export default {
  path: "/main/system/menu",
  name: "Menu",
  component: () => import("@/views/main/System/Menu/menu.vue"),
  children: []
};
